import { useEffect } from "react";

/**
 * 다크모드 클래스 토글에 맞춰 <meta name="theme-color">를 갱신해
 * Capacitor / iOS Safari 상태바 색을 동기화한다.
 */
export function useThemeColor(lightColor = "#ffffff", darkColor = "#0a0a0c") {
  useEffect(() => {
    const apply = () => {
      const isDark = document.documentElement.classList.contains("dark");
      const tag =
        document.querySelector<HTMLMetaElement>('meta[name="theme-color"]') ??
        (() => {
          const m = document.createElement("meta");
          m.name = "theme-color";
          document.head.appendChild(m);
          return m;
        })();
      tag.content = isDark ? darkColor : lightColor;
    };
    apply();
    const observer = new MutationObserver(apply);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, [lightColor, darkColor]);
}
